import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';

import { useBreadcrumbs } from '../../hooks/useBreadcrumbs';
import { ROUTES } from '../../constants/routes';

/**
 * مسیر دایرکتوری قابل کلیک برای همه پنل‌ها.
 */
export default function PanelBreadcrumbs() {
  const crumbs = useBreadcrumbs();
  if (!crumbs?.length) return null;

  const items = crumbs.map((crumb, index) => {
    const isLast = index === crumbs.length - 1;
    const isHome = crumb.path === ROUTES.DASHBOARD;
    const label = (
      <span className="inline-flex items-center gap-1">
        {isHome ? <HomeOutlined className="text-[11px]" /> : null}
        <span>{crumb.label}</span>
      </span>
    );

    if (!isLast && crumb.path) {
      return {
        key: `${crumb.path}-${index}`,
        title: (
          <Link
            to={crumb.path}
            className="!text-slate-500 hover:!text-brand-600 dark:!text-slate-400 dark:hover:!text-brand-400"
          >
            {label}
          </Link>
        ),
      };
    }

    return {
      key: `current-${index}`,
      title: <span className="text-slate-700 dark:text-slate-200">{label}</span>,
    };
  });

  return (
    <nav aria-label="مسیر صفحه" className="mb-1.5">
      <Breadcrumb
        items={items}
        className="text-[11px] sm:text-xs [&_.ant-breadcrumb-separator]:!mx-1.5 [&_.ant-breadcrumb-separator]:text-slate-300 dark:[&_.ant-breadcrumb-separator]:text-slate-600"
      />
    </nav>
  );
}
